import createAPI from './hotel-api';

const credentialsConf = {
  withCredentials: true,
  validateStatus: () => true,
};

const api = createAPI(process.env.MUJI_APP_HOST, {
  showNotification: true,
});

export function fetchPersonalOrder() {
  return api.getJson(`/portal/api/v2/order/list`, {}, credentialsConf);
}

export function createOrder( order ) {
  return api.postJson(`/portal/api/v2/order/`, order, credentialsConf);
}

export function fetchOrderInfo(id) {
  return api.getJson(`/portal/api/v2/order/${id}`, credentialsConf)
}
